<template>
  <div class="shujuzhongxinSheng">
    <BaseDrawer direction="rtl" :ShowClose="true">
      <div class="wrap">
        <Title />
        <div class="jcxx">
          <Collapse
            title="基础信息"
            @changeisReceiveFair="isReceiveFair"
            :isReceiveFair="jcxxIsShow"
          >
            <Tag
              v-for="(item, index) in opjcxx"
              :key="index"
              :name="item.name"
              :value="item.value"
            />
          </Collapse>
        </div>
        <div class="ztxx">
          <Collapse
            title="状态信息"
            :iconUrl="require('../../../assets/img/SSGJ/ztxxIcon.png')"
            @changeisReceiveFair="isReceiveFair"
            :isReceiveFair="ztxxIsShow"
          >
            <Tag
              v-for="(item, index) in opztxx"
              :key="index"
              :name="item.name"
              :value="item.value"
            />
          </Collapse>
        </div>
        <div class="ckll">
          <Collapse
            title="查看链路"
            :iconUrl="require('../../../assets/img/SSGJ/ckll.png')"
            @changeisReceiveFair="isReceiveFair"
            :isReceiveFair="ckllIsShow"
          >
            <div class="ul">
              <div
                class="li"
                @click="LinkLiPoint(opckll[0], 0)"
                :class="i == 0 ? 'ac' : ''"
              >
                <div class="TagButton_image">
                  <img :src="ckllimg[0]" alt />
                </div>
                <div class="TagButton_text">{{ opckll[0] }}</div>
              </div>
              <OPLinkDetails v-show="i == 0" :title="opckll[0]" />
            </div>
          </Collapse>
        </div>
        <div class="gjxx">
          <Collapse
            title="告警信息"
            :iconUrl="require('../../../assets/img/SSGJ/gjxxIcon.png')"
            @changeisReceiveFair="isReceiveFair"
            :isReceiveFair="gjxxIsShow"
          >
            <Table
              :CData="opgjxx"
              :NavData="['时间 ', '告警级别', '内容 ']"
              :NavWidth="['278px', '128px', '200px']"
            />
          </Collapse>
        </div>
      </div>
    </BaseDrawer>
  </div>
</template>

<script>
import Collapse from '@/components/common/communal/Collapse'
import Pagination from '@/components/common/communal/Pagination'
import Table from '@//components/common/communal/Table'
import Tag from '@/components/common/communal/Tag'
import TagButton from '@/components/common/communal/TagButton'
import BaseDrawer from '@/components/common/BaseDrawer'
import Title from '@/components/common/communal/Title'
import ChartLineArea from '@/components/charts/ChartLineArea'
import OPLinkDetails from '@/components/ShiShiGaoJing/common/OPLinkDetails'
export default {
  components: {
    Collapse,
    Pagination,
    Table,
    Tag,
    TagButton,
    Title,
    BaseDrawer,
    ChartLineArea,
    OPLinkDetails,
  },
  data() {
    return {
      opjcxx: [
        {
          name: '所属设备',
          value: 'SQL数据库服务',
        },
        {
          name: '端口编号',
          value: 'OP-1',
        },
        {
          name: '端口类型',
          value: 'OP',
        },
        {
          name: '对连设备',
          value: 'D04-ODF1',
        },
        {
          name: '对连端口',
          value: 'OP-1',
        },
      ],
      opztxx: [
        {
          name: '设备状态',
          value: '已占用',
        },
      ],
      opckll: ['PX-101'],
      opgjxx: [
        {
          time: '2022-07-11 12:00:00',
          content: '三级',
          second: '端口OP-1down',
        },
        {
          time: '2022-07-11 12:00:00',
          content: '三级',
          second: '端口OP-1down',
        },
        {
          time: '2022-07-11 12:00:00',
          content: '三级',
          second: '端口OP-1down',
        },
        {
          time: '2022-07-11 12:00:00',
          content: '三级',
          second: '端口OP-1down',
        },
        {
          time: '2022-07-11 12:00:00',
          content: '三级',
          second: '服务器连接异常',
        },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
        { time: '2022-07-11 12:00:00', content: '三级', second: '服务器故障' },
      ],
      ckllimg: [require('../../../assets/img/SSGJ/ckll.png')],
      btnimg: [
        require('../../../assets/img/SSGJ/sbfmIcon.png'),
        require('../../../assets/img/SSGJ/sbfmIcon.png'),
        require('../../../assets/img/SSGJ/sbfmIcon.png'),
      ],
      jcxxIsShow: true,
      ztxxIsShow: true,
      czzlIsShow: true,
      ckllIsShow: true,
      gjxxIsShow: true,
      lssjIsShow: true,
      i: -1,
    }
  },
  methods: {
    runInHole(p) {
      this.$emit('runInHole', p)
    },
    isReceiveFair(p) {
      let head = document.querySelectorAll('.Collapse_head')
      for (let index = 0; index < head.length; index++) {
        const element = head[index]
      }
      switch (p) {
        case '基础信息':
          this.jcxxIsShow = !this.jcxxIsShow
          break
        case '状态信息':
          this.ztxxIsShow = !this.ztxxIsShow
          break
        case '操作指令':
          this.czzlIsShow = !this.czzlIsShow
          break
        case '查看链路':
          this.ckllIsShow = !this.ckllIsShow
          break
        case '告警信息':
          this.gjxxIsShow = !this.gjxxIsShow
          break
        case '历史数据':
          this.lssjIsShow = !this.lssjIsShow
          break
      }
    },
    LinkLiPoint(item, index) {
      if (this.i == index) {
        this.i = -1
      } else {
        this.i = index
      }
    },
  },
}
</script>

<style lang="less" scoped>
.wrap {
  width: 680px;
  height: 1720px;
  background: url('../../../assets/img/WLTS/left.png') no-repeat;
  overflow-y: auto;
  overflow-x: hidden;
  .czzl {
    /deep/ .Collapse {
      .Collapse_main {
        .TagButton:nth-child(1) {
          .TagButton_image {
          }
        }
      }
    }
  }
  .ztxx {
    /deep/ .Collapse {
      .Collapse_main {
        .Tag:nth-child(1) {
          .Tag_right {
            color: #ff4a4a;
          }
        }
      }
    }
  }
  .ckll {
    .ul {
      .li {
        width: 100%;
        height: 50px;
        background: #189bfa;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        margin-bottom: 20px;
        .TagButton_image {
          width: 30px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;

          & > img {
            width: 100%;
            height: 100%;
          }
        }

        .TagButton_text {
          margin-left: 10px;
          font-size: 28px;
          font-family: '微软雅黑';
          color: #ffffff;
          font-weight: bold;
        }
      }
      .ac {
        width: 100%;
        height: 50px;
        background: #116caf;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 10px;
        margin-bottom: 20px;
      }
    }
  }
}
::-webkit-scrollbar {
  width: 0px;
  border-radius: 0px;
  background: rgba(17, 63, 89, 0.65);
}
::-webkit-scrollbar-thumb {
  width: 0px;
  border-radius: 0px;
  background: rgba(255, 255, 255, 0.15);
  min-height: 00px;
}
</style>